<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <div id="pass1FID">
      <v-card class="ep-rechner-box">
        <v-col cols="12" class="p-0">
          <div class="v-card__title p-0">
            <h2 class="v-card--head--title">
              {{ textStart }}
            </h2>
          </div>
        </v-col>
        <v-card-text>
          <v-row v-if="strAirline">
            <v-col cols="12">
              <v-alert dense type="warning">
                {{ strAirlineText }}
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pb-0">
              <a class="text-decoration-none pl-1" @click="alert = !alert">
                {{ selectedLang.FirstFlightTile3a }}
              </a><v-alert v-if="alert" :value="alert" border="top" color="primary" colored-border
                transition="scale-transition" class="text-center">
                <p v-html="selectedLang.FirstFlightTile3b"></p>
              </v-alert></v-col>
            <v-col cols="12" sm="6" class="pt-0 pb-2">
              <v-text-field v-model="flN" :counter="7" :rules="flNRules" :disabled="progress" :label="labelflN"
                :hint="selectedLang.FirstFlightTile3" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="pt-0 pb-2">
              <v-dialog attach v-model="datepickerfld" :close-on-content-click="false" transition="scale-transition"
                :disabled="progress" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="computedDateFormatted" :label="selectedLang.FirstFlightTile4"
                    :hint="selectedLang.FirstFlightTile5" persistent-hint readonly :disabled="progress"
                    :rules="flDRules" prepend-icon="event" v-on="on"></v-text-field>
                </template>
                <v-date-picker required v-model="flD" :value="flD" :first-day-of-week="1" :allowed-dates="allowedDates"
                  locale="de-DE" no-title :min="minflD" @input="datepickerfld = false"></v-date-picker>
              </v-dialog>
            </v-col>
            <v-cols cols="12" class="pt-0 pb-2">
              <p class="text-center mb-0 mt-0" v-html="teaser">
              </p>
            </v-cols>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row v-if="!progress">
            <v-col cols="12">
              <v-btn id="search-fl" block :loading="loading" :disabled="!valid || progress" class="btn-ep-next-step"
                @click="validate">
                {{ buttonText }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="progress">
            <v-col cols="12">
              <v-btn block class="btn-ep-back-to" @click="restart">{{
                selectedLang.AdditionalFlightsTile74
              }}</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </div>
  </v-form>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import dayjs from "dayjs";
export default {
  name: "FirstFlightTile",
  data: function () {
    return {
      alert: false,
      datepickerfld: false,
      flN: "",
      flD: "",
      valid: false,
      minflD: "",
      fromStart: false,
      inBC: "",
      hasAirl: "",
      strAirline: false,
      strAirlineText: "",
      loading: false,
    };
  },
  computed: {
    ...mapState([
      "manRunSs",
      "dataFS",
      "kiofCla",
      "progress",
      "selectedDiv",
      "flDRules",
      "flNRules",
      "selectedLang",
      "cases",
      "airportMap",
      "airlineMap",
    ]),
    ...mapGetters(["options"]),
    computedDateFormatted() {
      return this.formatDate(this.flD);
    },
    textStart() {
      if (this.inBC == "storno") {
        return this.selectedLang.FirstFlightTile1a;
      } else {
        return this.selectedLang.FirstFlightTile1;
      }
    },
    labelflN() {
      if (this.inBC == "storno") {
        // if (this.hasAirl != "") {
        //   return this.selectedLang.FirstFlightTile2a.replace(
        //     "FR",
        //     this.hasAirl
        //   );
        // } else {
        return this.selectedLang.FirstFlightTile2a;
        //}
      } else {
        return this.selectedLang.FirstFlightTile2;
      }
    },
    showSHint() {
      if (this.inBC == "storno") {
        return true;
      } else {
        return false;
      }
    },
    buttonText() {
      if (this.inBC == "storno") {
        return this.selectedLang.FirstFlightTile6a;
      } else {
        return this.selectedLang.FirstFlightTile6;
      }
    },
    teaser() {
      if (this.inBC == "storno") {
        return this.$store.state.selectedLang.FirstFlightTile6c;
      } else {
        return this.$store.state.selectedLang.FirstFlightTile6b;
      }
    }
  },
  watch: {
    flN() {
      if (this.flN.length >= 2 && !this.fromStart && !this.isEasy(this.flN)) {
        var airlineFM = this.airlineMap.get(
          this.flN.toUpperCase().substring(0, 2)
        );
        if (airlineFM == undefined) {
          this.strAirlineText = this.selectedLang.FirstFlightTile13;
          this.strAirline = true;
        } else if (airlineFM.airlineFIRM == null) {
          this.strAirlineText = this.formatDBText(
            this.selectedLang.FirstFlightTile12,
            { airlineName: airlineFM.airlineNAME }
          );
          this.strAirline = true;
        } else {
          this.strAirline = false;
        }
      } else {
        this.strAirline = false;
      }
    },
  },
  mounted: function () {
    const queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    let flDA = new Date();
    this.minflD = parseInt(flDA.getFullYear() - 3) + "-01-01";
    flDA.setDate(flDA.getDate() + 7);

    var flnFS = sessionStorage.getItem("flN");
    var fldFS = this.parseLocal2ISO(new Date(sessionStorage.getItem("flD")));

    this.getAirports();
    this.getAirlines();

    if (flnFS != null && fldFS != null) {
      this.fromStart = true;
      this.flN = flnFS;
      this.flD = fldFS;
      this.validate();
      sessionStorage.removeItem("flN");
      sessionStorage.removeItem("flD");
    }

    if (urlParams.has("case")) {
      this.inBC = urlParams.get("case");
    }

    if (urlParams.has("airline")) {
      this.hasAirl = urlParams.get("airline");
    }
  },
  methods: {
    ...mapActions([
      "setSelectedDiv",
      "setFSDataVar",
      "setVar",
      "getFlightData",
      "goToStep",
      "getAirports",
      "getAirlines",
      "killRun",
    ]),
    allowedDates: function (val) {
      let flDA = dayjs();
      let mmHack = this.mmHacker(flDA);
      let vas = val.split("-");
      return (
        12 - parseInt(mmHack) > 0 ||
        parseInt(parseInt(vas[0]) - (flDA.year() - 3)) >= 1
      );
    },
    mmHacker(val) {
      return parseInt(val.month() + 1) < 10
        ? "0" + parseInt(val.month() + 1)
        : parseInt(val.month() + 1);
    },
    ddHacker(val) {
      return parseInt(val.date()) < 10
        ? "0" + parseInt(val.date())
        : parseInt(val.date());
    },
    setMinAMax4AdditionalFlights(val) {
      var utc = require("dayjs/plugin/utc");
      dayjs.extend(utc);
      let splittedFLD = val.split("-");
      let zbMaxDate =
        splittedFLD[0] + "-" + splittedFLD[1] + "-" + splittedFLD[2];
      this.setVar({ pos: "zbMaxDate", val: zbMaxDate });
      this.setVar({ pos: "anMinDate", val: zbMaxDate });
      this.setVar({ pos: "maxflDTRF", val: zbMaxDate });
      let tempDate = dayjs.utc(val + " 12:00");
      tempDate = tempDate.subtract(1, "day");
      let mmHack = this.mmHacker(tempDate);
      let ddHack = this.ddHacker(tempDate);
      let zbMinDate = tempDate.year() + "-" + mmHack + "-" + ddHack;
      this.setVar({ pos: "zbMinDate", val: zbMinDate });
      tempDate = tempDate.add(2, "day");
      mmHack = this.mmHacker(tempDate);
      ddHack = this.ddHacker(tempDate);
      let anMaxDate = tempDate.year() + "-" + mmHack + "-" + ddHack;
      this.setVar({ pos: "anMaxDate", val: anMaxDate });
      tempDate = tempDate.add(1, "day");
      mmHack = this.mmHacker(tempDate);
      ddHack = this.ddHacker(tempDate);
      let actMaxDate = tempDate.year() + "-" + mmHack + "-" + ddHack;
      this.setVar({ pos: "actMaxDate", val: actMaxDate });
    },
    parseLocal2ISO(val) {
      let tempDate = dayjs(val);
      let mmHack = this.mmHacker(tempDate);
      let ddHack = this.ddHacker(tempDate);
      return tempDate.year() + "-" + mmHack + "-" + ddHack;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    goToMan() {
      this.setFSDataVar({ pos: "res", val: "ma" });
      this.setVar({ pos: "manRunSs", val: true });
      this.validate();
    },
    parseDate4DisplayT(val) {
      const event = new Date(val);
      const optionst = {
        hour: "2-digit",
        minute: "2-digit",
      };
      return event.toLocaleTimeString("de-DE", optionst);
    },
    parseflN(val) {
      let tempArr = val.toString().split("");
      for (var i = 2; i < tempArr.length; i++) {
        if (parseInt(tempArr[i]) == 0) {
          tempArr[i] = "";
        } else if (parseInt(tempArr[i]) > 0) {
          break;
        }
      }
      let newVal = "";
      tempArr.forEach((element) => {
        newVal += element;
      });
      return newVal;
    },
    parseDate4DisplayD(val) {
      const event = new Date(val);
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      return event.toLocaleDateString("de-DE", options);
    },
    isEasy(fln) {
      var val = fln.toUpperCase().substring(0, 3);
      if (val == "EZY" || val == "EJU" || val == "EZS") {
        return true;
      } else {
        return false;
      }
    },
    restart() {
      this.killRun({ vm: this });
    },
    formatDBText(str, values) {
      var result;
      var reg = /(\w+.?\w+.?\w+.?\w+)(?= }})/g;
      while ((result = reg.exec(str)) !== null) {
        let key = String(str).match(reg)[0];
        if (Object.keys(values).includes(key)) {
          str = str.replace("{{ " + key + " }}", values[key]);
        }
      }
      result = str;
      return result;
    },
    async validate() {
      this.flN = this.flN.toUpperCase().trim();
      this.flN = await this.parseflN(this.flN);
      let depDate1 = "";
      let arrDate1 = "";
      const date1 = dayjs();
      const date2 = dayjs(this.flD);
      const d915 = dayjs("2021-09-15");
      let dateDiff = date1.diff(date2, "day");
      let d915Diff = d915.diff(date2, "day");

      if (dateDiff == 0) {
        this.setVar({ pos: "showWarning", val: false });
      }

      if (dateDiff < 0) {
        this.cases = this.cases.splice(4, 2);
        this.cases = this.cases.splice(0, 1);
        if (dateDiff < -3) {
          this.cases = this.cases.splice(0, 1);
        }
      }

      if (dateDiff > 0) {
        this.cases = this.cases.splice(3, 1);
      }

      this.setVar({ pos: "cases", val: this.cases });

      if (d915Diff <= 0) {
        this.setVar({ pos: "af915", val: true });
      }

      if (this.$refs.form.validate()) {
        this.loading = true;
        await this.getFlightData({
          flN: this.flN,
          flD: this.flD,
          target: "dataFS",
        }).then(() => {
          this.loading = false;
        });

        if (this.dataFS.res == "ex") {
          this.setSelectedDiv("32");
          this.setVar({ pos: "rejectionMessage", val: this.dataFS.message });
        } else {
          this.setVar({ pos: "flN", val: this.flN });
          this.setVar({ pos: "flD", val: this.flD });
          let flDA = this.flD.toString().split("-");
          let ynm1 = parseInt(flDA[0]) - 1;
          let maxGeb = ynm1 + "-" + flDA[1] + "-" + flDA[2];
          this.setVar({ pos: "maxGeb", val: maxGeb });
          this.setVar({
            pos: "computedDateFormatted",
            val: this.computedDateFormatted,
          });
          if (this.dataFS.res == "fs") {
            if (
              this.dataFS.airports.airportSCC != "DE" &&
              this.dataFS.airports.airportTCC != "DE"
            ) {
              this.setVar({ pos: "flOODE", val: true });
            }
            depDate1 = this.parseLocal2ISO(
              new Date(this.dataFS.arrivalDateLocal)
            );
            let time1 = this.parseDate4DisplayT(this.dataFS.arrivalDateLocal);
            this.setVar({ pos: "timeDF1F", val: time1 });
            var ttime1 = this.parseDate4DisplayT(
              this.dataFS.departureDateLocal
            );
            arrDate1 = this.parseLocal2ISO(
              new Date(this.dataFS.arrivalDateLocal)
            );
            let tempDelay = parseInt(this.dataFS.delay);
            let time2 = "";
            if (tempDelay >= -120) {
              let tempDateArr = new Date(this.dataFS.arrivalDateLocal);
              tempDateArr = new Date(tempDateArr.getTime() + tempDelay * 60000);
              time2 = this.parseDate4DisplayT(tempDateArr);
              arrDate1 = this.parseLocal2ISO(tempDateArr);
            } else {
              time2 = this.parseDate4DisplayT(this.dataFS.arrivalDateLocal);
              arrDate1 = this.parseLocal2ISO(
                new Date(this.dataFS.arrivalDateLocal)
              );
            }
            this.setVar({ pos: "timeAF1F", val: time2 });
            var ttime2 = this.parseDate4DisplayT(this.dataFS.arrivalDateLocal);
            let fs4DisplayDep =
              this.parseDate4DisplayD(this.dataFS.departureDateLocal) +
              " " +
              ttime1;
            this.setVar({ pos: "fs4DisplayDep", val: fs4DisplayDep });
            let fs4DisplayArr =
              this.parseDate4DisplayD(this.dataFS.arrivalDateLocal) +
              " " +
              ttime2;
            this.setVar({ pos: "fs4DisplayArr", val: fs4DisplayArr });
            this.setVar({ pos: "kiofCla", val: this.dataFS.status });

            await this.setVar({
              pos: "manDepAir",
              val: this.airportMap.get(this.dataFS.airports.airportSC),
            });
            await this.setVar({
              pos: "manArrAir",
              val: this.airportMap.get(this.dataFS.airports.airportTC),
            });
            switch (this.kiofCla) {
              case "L":
                if (tempDelay > 1) {
                  this.setVar({
                    pos: "selectedCase",
                    val: {
                      text: this.$store.state.selectedLang.FirstFlightTile9,
                      val: "L",
                    },
                  });
                }
                break;
              case "C":
                this.setVar({
                  pos: "selectedCase",
                  val: {
                    text: this.$store.state.selectedLang.FirstFlightTile10,
                    val: "C",
                  },
                });
                break;
              default:
                break;
            }
          } else {
            depDate1 = this.parseLocal2ISO(new Date(this.flD));
            arrDate1 = this.parseLocal2ISO(new Date(this.flD));
          }
          this.setMinAMax4AdditionalFlights(this.flD);
          this.setVar({ pos: "depDateF1F", val: depDate1 });
          this.setVar({ pos: "arrDateF1F", val: arrDate1 });
          this.setVar({ pos: "startposition", val: window.scrollY });
          let dateFormatted = this.formatDate(this.flD);
          this.setVar({ pos: "dateFormatted", val: dateFormatted });
          this.setSelectedDiv("20");
          this.goToStep({
            vm: this,
            val: this.selectedDiv,
          });
        }
        this.setVar({ pos: "progress", val: true });
      }
      this.$gtag.event("1. Flug " + this.flN + " am " + this.formatDate(this.flD), {
        event_category: "Rechner",
        event_label: "1. Flug " + this.flN + " am " + this.formatDate(this.flD),
      });
      this.$gtag.event("1. Flug eingegeben", {
        event_category: "Rechner",
        event_label: "1. Flug eingegeben",
      });
    },
  },
};
</script>
